import {assert, assertAndContinue} from 'Asserts';
import {DataType} from 'data-frames/DataFrameTypes';
import {
  AxisCompatibleDataType,
  AxisConfig,
  AxisScale,
  DATA_TYPE_TO_SUPPORTED_AXIS_SCALE,
  isContinuousAxisConfig,
} from 'ui-library/charting/Types';

/**
 * Validates an axis config for a given data type.
 *
 * Throws when:
 *   - Type is not compatible with axis scale
 *   - Type is non-NUMBER, and axis includes zero
 *   - Axis is log scale, and axis includes zero
 *
 * Does not throw for non-continuous axis configs (i.e. if there's no `includeZero` and no `scale` field)
 */
export function validateAxis(axisConfig: AxisConfig, axisType: AxisCompatibleDataType): void {
  if (!isContinuousAxisConfig(axisConfig)) {
    return;
  }

  assert(
    DATA_TYPE_TO_SUPPORTED_AXIS_SCALE[axisType].includes(axisConfig.scale),
    `${axisType} axis not compatible with ${axisConfig.scale} scale`
  );
  if (axisType !== DataType.NUMBER) {
    assert(!axisConfig.includeZero, `${axisType} axes do not support including zero`);
  }
  if (axisConfig.scale === AxisScale.LOG) {
    assert(!axisConfig.includeZero, 'Log scales do not support including zero');
  }

  assertAndContinue(
    axisConfig.min == null || axisConfig.max == null || axisConfig.min < axisConfig.max,
    "Expected axis's min to be less than its max when both are set.",
    {axisConfig}
  );
}
